module.exports = __webpack_public_path__ + "static/media/291748.ad2c0676.png";